var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.366,5.767 C4.366,5.767 0.273,1.581 0.273,1.581 C-0.081,1.219 -0.081,0.633 0.273,0.271 C0.273,0.271 0.273,0.271 0.273,0.271 C0.627,-0.091 1.201,-0.091 1.555,0.271 C1.555,0.271 4.666,3.452 4.666,3.452 C4.854,3.645 5.160,3.645 5.348,3.452 C5.348,3.452 8.460,0.270 8.460,0.270 C8.814,-0.092 9.387,-0.092 9.741,0.270 C9.741,0.270 9.741,0.270 9.741,0.270 C10.095,0.632 10.095,1.219 9.741,1.581 C9.741,1.581 5.648,5.767 5.648,5.767 C5.294,6.129 4.720,6.129 4.366,5.767 Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default ForwardRef;